<template>
  <div>
    <list
      row-key="SourceTypeId"
      ref="list"
      unit="单据类型"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :queryParamsAppend="params"
      :get-data-func="api.list"
      :showTrendTable="isShow"
      urlHash="basedata/basedoc/billtype"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
export default {
  mixins: [listMixin],
  components: { list },
  props: {
    isShow: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      api: require("@/api/ba/sourceType").default,
      params: {
        // TransportName: "",
        // TransportNo: "",
        // Status: null,
        ShowType:1
      },
    };
  },
  methods: {
    getFuncData(){
      return new Promise(resolve=>{
        this.api.list({}).then(res=>{
          // console.log(res);
          resolve({Data:res.Data})
        })
      })
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>